import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { customElement } from 'lit/decorators/custom-element.js';
import { oipModuleItemStyle } from './oip-module-item.style';

@customElement('sbk-oip-module-item')
export class SbkOipModuleItem extends LitElement {

    static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

    @property({type: String})
    headline = '';

    static get styles() {
        return oipModuleItemStyle;
    }


    render() {
        return html`
      <div class="container">
          <p><strong>${this.headline}</strong></p>
          <div class="buttons">
              <slot></slot>
          </div>
      </div>
    `;
    }
}
